import { render } from "./RequisiteList.vue?vue&type=template&id=17f540ea&scoped=true"
import script from "./RequisiteList.vue?vue&type=script&lang=js"
export * from "./RequisiteList.vue?vue&type=script&lang=js"

import "./RequisiteList.vue?vue&type=style&index=0&id=17f540ea&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f540ea"]])

export default __exports__